import { getAllChildren } from 'components/TableLikeTree/utils';
import { IconArrowUp, IconArrowDown, Button } from 'uikit';
import { runOn } from 'utils/runOnRefExists';

import { useEffect, useRef, useState } from 'react';

import type { ITableStructureItem } from '../../BimVersionViewStructure';

import Style from './HierarchyColumnVersionCell.module.css';

export interface IHierarchyColumnCell {
    item: ITableStructureItem;
    shownIds: number[];
    hideItems: (itemsIds: number[]) => any;
    showItems: (itemsIds: number[]) => any;
}

export const itemLevelMargin = 40;

const setOpacity = (element: any, value: string) => {
    if (element) {
        (element as HTMLDivElement).style.opacity = value;
    }
};

export const HierarchyVersionColumnCell: React.FC<IHierarchyColumnCell> = (props) => {
    const { item, shownIds, showItems, hideItems } = props;
    const { children, title, id, parent } = item;
    const areChildrenShown = children?.every((child: { id: number }) => shownIds.includes(child.id));
    const allChildrenIds = getAllChildren(item).map((c) => c.id);
    const ref = useRef<HTMLDivElement>(null);

    const [levelMarginShift, setLevelMarginShift] = useState(0);

    const onClick = () => {
        if (areChildrenShown) {
            hideItems(allChildrenIds);
        } else {
            showItems(allChildrenIds);
        }
    };

    useEffect(() => {
        if (ref.current && parent) {
            const table = ref.current.closest('.Table');
            const getParent = () => table?.getElementsByClassName(`hierarchy-column-cell-${parent.id}`);
            const parentColumnCell = getParent();

            setOpacity(ref.current, '0');
            setOpacity(parentColumnCell?.[0], '0');

            runOn(
                () => {
                    const parentCell = getParent();

                    return parseInt((parentCell?.[0] as HTMLDivElement)?.style?.marginLeft, 10);
                },
                () => {
                    const parentCell = getParent();

                    if (parentCell?.length) {
                        const {
                            clientWidth: width,
                            style: { marginLeft },
                        } = parentCell[0] as HTMLDivElement;
                        const titleBlock = parentCell[0].getElementsByClassName('hierarchy-column-cell-title');

                        if (titleBlock.length) {
                            setLevelMarginShift(width - titleBlock[0].clientWidth + parseInt(marginLeft, 10));
                        }

                        setTimeout(() => {
                            setOpacity(ref.current, '1');
                            setOpacity(parentCell?.[0], '1');
                        }, 1);
                    }
                },
            );
        }
    }, [parent]);

    return (
        <div
            ref={ref}
            className={`${Style.hierarchyColumnCell} hierarchy-column-cell-${id}`}
            style={{ marginLeft: levelMarginShift }}
        >
            {!!children?.length && (
                <Button
                    size="xs"
                    view="clear"
                    onlyIcon
                    iconRight={areChildrenShown ? IconArrowUp : IconArrowDown}
                    onClick={onClick}
                />
            )}
            <div className="hierarchy-column-cell-title">{title}</div>
        </div>
    );
};

HierarchyVersionColumnCell.displayName = 'HierarchyVersionColumnCell';
